import { siteUrls } from "../utils/siteUrls";

export const pagesList = [
    { icon: "icon-1",  text: "Omluvenky",        to: siteUrls.weekend, key: "weekend" },
    { icon: "icon-2",  text: "Nástěnka",         to: siteUrls.news, key: "news" },
    { icon: "icon-3",  text: "Zprávy",           to: siteUrls.chat, key: "chat" },
    { icon: "icon-4",  text: "Dotazníky",        to: siteUrls.poll, key: "poll" },
    { icon: "icon-7",  text: "Kurzy",            to: siteUrls.courses, key: "courses" },
    { icon: "icon-10", text: "Akce",             to: siteUrls.events, key: "events" },
    { icon: "icon-8",  text: "Kontakty",         to: siteUrls.contacts, key: "contacts" },
    { icon: "icon-9",  text: "Fotogalerie",         to: siteUrls.comingSoon, key: "comingSoon" },
    { icon: "icon-6",  text: "Výplatní paska",         to: siteUrls.comingSoon, key: "comingSoon" },
];